module.exports = __webpack_public_path__ + "img/p07.782072f5.png";